import {Component, ElementRef, Input} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    selector: 'hc-music',
    templateUrl: 'hc-music.html',
    providers: []
})
export class HcMusic {

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;
    @Input('index') index: number;
    @Input('first') first: boolean;

    constructor(public element: ElementRef, public sanitizer: DomSanitizer) {

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/hc-music/hc-music.ts